import {isNil} from 'ramda';

import {BATTERY_CHARGE_MAX} from '@dms/shared';

import {Nullish} from 'shared/web';

/** The API stores the battery charge as a 0–1 fraction, not as a percent. */
const MIN_BATTERY_CHARGE_FRACTION = 0;
const MAX_BATTERY_CHARGE_FRACTION = 1;

/**
 * @about Parses the battery charge level stored by the API as a 0–1 fraction string into the
 * whole percent the UI works with. A missing, blank, unparseable or out-of-range value parses to
 * null so the caller can omit the level instead of showing a wrong one.
 */
export function parseBatteryCharge(value: string | Nullish): number | null {
  if (isNil(value) || value.trim() === '') {
    return null;
  }

  const fraction = Number(value);

  if (
    !Number.isFinite(fraction) ||
    fraction < MIN_BATTERY_CHARGE_FRACTION ||
    fraction > MAX_BATTERY_CHARGE_FRACTION
  ) {
    return null;
  }

  return Math.round(fraction * BATTERY_CHARGE_MAX);
}
